import * as _ from 'lodash';
import moment from 'moment';

export interface IFilter<T> {
    id: string;
    display: string;
    template: FilterTemplate;
    options: IFilterOption<T>[];
    rule: (T) => boolean;
    count?: (T) => number;
}

export interface IUrlFilter {
    filterId: string,
    selectedOptions: string[]
}

export interface IFilterOption<T> {
    id: string;
    rule: (T) => boolean;
    display: string;
    selected: boolean;
    count?: (T) => number;
}

export interface IDateFilter {
    display: string;
    startDate: moment.Moment;
    endDate: moment.Moment;
    id: string;
    selected: boolean;
}

export interface IToggleFilter<T> {
    id: string;
    isSelected: boolean;
    rule: (T) => boolean;
}

export enum FilterTemplate {
    CHECKBOX,
    RADIO
}

export class Filter<T> implements IFilter<T> {
    id: string;
    display: string;
    options: IFilterOption<T>[];
    template: FilterTemplate;
    
    constructor(options: { options: IFilterOption<T>[], template: FilterTemplate, id: string, display: string }) {
        _.extend(this, options);

        // Create a new options array
        this.options = Array.prototype.slice.call(options.options);
    };

    rule = function (item: T) {
        let selectedOptions = this.options && this.options.some(o => o.selected)
            ? this.options.filter(o => o.selected)
            : [] as IFilterOption<T>[];

        if (selectedOptions.length === 0) {
            return true;
        }

        return selectedOptions.some(o => o.rule(item));
    }
}

export interface IFilterTextMap {
    filterId: string;
    display: string;
    options: IOptionTextMap[];
}

export interface IOptionTextMap {
    optionId: string;
    display: string;
    count: number;
}

export interface IDropdownOption {
    id: string;
    display: string;
    selected: boolean;
    isDisabled?: boolean;
    isPinned?: boolean;
}

export interface ISuperSelectSource {
    id: string;
    name: string;
    size: string;
    selected: boolean;
}

export const defaultDivider = { display: '---', id: 'divider', isDisabled: true, selected: false };

export function getDisabledDropdownItems(pinnedNames: string[], items: IDropdownOption[]): IDropdownOption[] {
    var pinnedItems = [];
    if (pinnedNames) {
        [].forEach.call(pinnedNames, (item) => {
            var value = item.toLowerCase();
            if (items.some(x => x.display.toLowerCase() === value)) {
                pinnedItems.push({ ...items.filter(x => x.display.toLowerCase() === value)[0], isPinned: true });
            }
        });

        // Add the disabled divider
        if (pinnedItems.length > 0) {
            pinnedItems.push(defaultDivider);
        }
    }
    return pinnedItems;
}